<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('conservatory_applications')"
                        :isColumns="true"
                        :actions="actions"
                        @filter-div-status="datatable.filterStatus=$event"
                >
                    <template v-slot:columns>
                        <div class="mb-1" v-for="(column,key) in datatable.columns">
                            <b-form-checkbox
                                :id="'checkbox-'+key"
                                :name="'checkbox-'+key"
                                :value="false"
                                :unchecked-value="true"
                                v-model="column.hidden"
                                v-if="column.field!='buttons'"
                            >
                                {{ column.label }}
                            </b-form-checkbox>
                        </div>
                    </template>
                </Header>
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('conservatory_applications')"
                              :isColumns="true"
                              :actions="actions"
                              @filter-div-status="datatable.filterStatus=$event"
                >
                    <template v-slot:columns>
                        <div class="mb-1" v-for="(column,key) in datatable.columns">
                            <b-form-checkbox
                                :id="'checkbox-'+key"
                                :name="'checkbox-'+key"
                                :value="false"
                                :unchecked-value="true"
                                v-model="column.hidden"
                                v-if="column.field!='buttons'"
                            >
                                {{ column.label }}
                            </b-form-checkbox>
                        </div>
                    </template>
                </HeaderMobile>
            </template>
            <datatable-filter
                v-show="datatable.filterStatus"
                :otherButton="{ show: true, title: $t('message_bulk_btn'), emit:'bulkMessage'}"
                :export-excel="true"
                @exportExcel="excelExport"
                @bulkMessage="bulkMessage"
                @filter="filter"
                @filterClear="filterClear">
                <b-row>
                    <b-col cols="12" md="8">
                        <b-row>
                            <b-col md="6">
                                <b-form-group :label="$t('period')">
                                    <semesters-selectbox v-model="datatable.queryParams.filter.semester_id"
                                                     :multiple="false"/>
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <b-form-group :label="$t('application_group')">
                                    <multi-selectbox v-model="datatable.queryParams.filter.application_group"
                                                     :options="groupOptions"
                                                     :multiple="false"/>
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <b-form-group :label="$t('name')">
                                    <b-form-input type="text" v-model="datatable.queryParams.filter.name"></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <b-form-group :label="$t('surname')">
                                    <b-form-input type="text" v-model="datatable.queryParams.filter.surname"></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <b-form-group :label="$t('program')">
                                    <program-selectbox v-model="datatable.queryParams.filter.program_code" :major_type="'A'" :faculty_code="11" />
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <b-form-group :label="$t('branch')">
                                    <multi-selectbox v-model="datatable.queryParams.filter.program_detail"
                                                     :options="branchs" />
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <b-form-group :label="$t('exam_date_enter')">
                                    <true-false-selectbox v-model="datatable.queryParams.filter.is_publish_exam_date"
                                                          :multiple="false"/>
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <b-form-group :label="$t('status')">
                                    <multi-selectbox v-model="datatable.queryParams.filter.status"
                                                     :options="statusOptions"
                                                     :multiple="false"/>
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <b-form-group :label="$t('have_a_message')">
                                    <multi-selectbox v-model="datatable.queryParams.filter.have_message"
                                                     :options="haveMessageOptions"
                                                     :multiple="false"/>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" md="4">
                        <b-form-group :label="$t('national_id')">
                            <lined-textarea
                                v-model="datatable.queryParams.filter.national_id"
                                :nowrap="false"
                                :disabled="false"
                                :styles="{ height: '18.2em', resize: 'both' }"
                            >
                            </lined-textarea>
                        </b-form-group>
                    </b-col>
                </b-row>
            </datatable-filter>
            <datatable :isLoading.sync="datatable.isLoading"
                       :columns="datatable.columns"
                       :rows="datatable.rows"
                       :total="datatable.total"
                       :queryParams="datatable.queryParams"
                       @on-page-change="onPageChange"
                       @on-sort-change="onSortChange"
                       @on-per-page-change="onPerPageChange"
                       v-show="datatable.showTable"
            >
            </datatable>
            <CommonModal ref="updateModal" size="xl"  :onHideOnlyX="true" @bHideModalHeaderClose="formClear">
                <template v-slot:CommonModalTitle>
                    <div>{{ updateTitle }}</div>
                </template>
                <template v-slot:CommonModalContent>
                    <update-form
                        :update-data="updateData"
                        :update-mode="updateMode"
                        @updated="afterUpdate"
                        @updatedMsg="afterUpdateMsg"
                        :goTab="goTabIndex"
                        v-if="formProcess==='updateModal'"></update-form>
                </template>
            </CommonModal>
            <CommonModal ref="bulkMessageModal" size="xl">
                <template v-slot:CommonModalTitle>
                    <div>{{ $t('message_bulk_title') }}</div>
                </template>
                <template v-slot:CommonModalContent>
                    <div>
                        <ValidationObserver ref="bulkMessageFormValidate">
                            <b-alert show variant="secondary">
                                <b-row>
                                    <b-col cols="12" class="mb-2">
                                        <b-badge>{{ $t('message_bulk_to') }}</b-badge>
                                    </b-col>
                                    <b-col cols="9" md="10">
                                        <ValidationProvider name="message" rules="required" v-slot="{errors}">
                                            <b-form-group>
                                                <b-form-textarea v-model="bulkMsgForm.message"
                                                                 :class="errors[0] ? 'is-invalid':''"
                                                                 rows="3"
                                                                 :placeholder="$t('message')"
                                                />
                                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                                            </b-form-group>
                                        </ValidationProvider>
                                    </b-col>
                                    <b-col cols="3" md="2">
                                        <b-button block variant="primary" @click="bulkMessageSend">
                                            {{$t('send')}}
                                        </b-button>
                                    </b-col>
                                </b-row>
                            </b-alert>
                        </ValidationObserver>
                    </div>
                </template>
            </CommonModal>
            <CommonModal id="importFormModal" size="lg" :onHideOnlyX="true">
                <template v-slot:CommonModalTitle>
                    {{ importModalTitle }}
                </template>
                <template v-slot:CommonModalContent>
                    <b-row>
                        <b-col cols="12" md="10">
                            <ValidationObserver ref="importFormValidate">
                                <ValidationProvider name="file" rules="required" v-slot="{errors}">
                                    <b-input-group class="mb-0">
                                        <b-form-file v-model="importFile"
                                                     :placeholder="$t('upload_file')"
                                                     :state="errors[0] ? false : null"
                                                     ref="fileInput2"
                                        />
                                        <b-input-group-append>
                                            <b-button variant="outline-secondary" @click="$refs.fileInput2.$el.childNodes[0].click()">{{ $t('browse') }}</b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                    <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                                </ValidationProvider>
                            </ValidationObserver>
                        </b-col>
                        <b-col cols="12" md="2" class="d-flex justify-content-end">
                            <b-button variant="primary" @click="uploadFile">{{ $t('upload') }}</b-button>
                        </b-col>
                    </b-row>
                </template>
            </CommonModal>
        </app-layout>
    </div>
</template>
<script>
    // Template
    import AppLayout from '@/layouts/AppLayout'
    import Header from '@/layouts/AppLayout/Header'
    import HeaderMobile from '@/layouts/AppLayout/HeaderMobile'

    // Components
    import DatatableFilter from '@/components/datatable/DatatableFilter'
    import Datatable from '@/components/datatable/Datatable'
    import ProgramSelectbox from "@/components/interactive-fields/ProgramSelectbox"
    import MultiSelectbox from '@/components/interactive-fields/MultiSelectbox'
    import CommonModal from '@/components/elements/CommonModal'
    import TrueFalseSelectbox from '@/components/interactive-fields/TrueFalseSelectbox'
    import LinedTextarea from "@/components/elements/LinedTextarea"
    import SemestersSelectbox from "@/components/interactive-fields/SemestersSelectbox"

    // Pages
    import UpdateForm from './UpdateForm'

    // Services
    import ConservatoryService from "@/services/ConservatoryService"

    // Others
    import qs from 'qs'
    import Branchs from "@/modules/conservatoryApplication/data/Branchs"
    import { ValidationObserver, ValidationProvider } from 'vee-validate'

    export default {
        components: {
            AppLayout,
            Header,
            HeaderMobile,
            ValidationProvider,
            ValidationObserver,

            ProgramSelectbox,
            MultiSelectbox,
            CommonModal,
            TrueFalseSelectbox,
            LinedTextarea,
            SemestersSelectbox,

            UpdateForm,
            DatatableFilter,
            Datatable,
        },
        metaInfo() {
            return {
                title: this.$t('conservatory_applications')
            }
        },
        data() {
            return {
                formProcess:null,
                datatable: {
                    actions: [],
                    isLoading: false,
                    columns: [
                        {
                            label: '',
                            field: 'buttons',
                            html: true,
                            sortable: false,
                            tdClass: 'p-0 text-center w-40 align-middle',
                            buttons: [
                                {
                                    text: this.$t('view'),
                                    class: 'ri-search-eye-line align-middle top-minus-1 mr-3 text-muted',
                                    callback: (row) => {
                                        this.openUpdateModal(row, false,0)
                                    },
                                    permission:"conservatoryapplication_index"
                                },
                                {
                                    text: this.$t('edit'),
                                    class: 'ri-edit-box-line align-middle top-minus-1 mr-3 text-muted',
                                    callback: (row) => {
                                        this.openUpdateModal(row, true, 0)
                                    },
                                    permission:"conservatoryapplication_update"
                                },
                                {
                                    text: this.$t('exam_info_enter'),
                                    class: 'ri-calendar-schedule-line align-middle top-minus-1 mr-3 text-muted',
                                    callback: (row) => {
                                        this.openUpdateModal(row, true, 3)
                                    },
                                    permission:"conservatoryapplication_update"
                                },
                                {
                                    text: this.$t('delete'),
                                    class: 'ri-delete-bin-7-line align-middle top-minus-1 mr-3 text-muted',
                                    callback: (row) => {
                                        this.deleteApplication(row)
                                    },
                                    permission:"conservatoryapplication_deleteconservatoryapplication"
                                }
                            ]
                        },
                        {
                            label: this.$t('id'),
                            field: 'id',
                            hidden: false
                        },
                        {
                            label: this.$t('name'),
                            field: 'name',
                            hidden: false
                        },
                        {
                            label: this.$t('surname'),
                            field: 'surname',
                            hidden: false,
                        },
                        {
                            label: this.$t('program'),
                            field: this.getLocaleField('program_name'),
                            hidden: false
                        },
                        {
                            label: this.$t('branch'),
                            field: 'program_detail',
                            hidden: false,
                            formatFn: (row) => {
                                if (row[0] === 'jazz') {
                                    return this.$t('jazz');
                                } else if (row[0] === 'turkish_music') {
                                    return this.$t('turkish_music');
                                } else if (row[0] === 'classic_music') {
                                    return this.$t('classic_music');
                                }  else if (row[0] === 'jazz_vocal') {
                                    return this.$t('jazz_vocal');
                                } else if (row[0] === 'composition_arrangement') {
                                    return this.$t('composition_arrangement');
                                } else if (row[0] === 'music_teories') {
                                    return this.$t('music_teories');
                                } else if (row[0] === 'classical_turkish_music') {
                                    return this.$t('classical_turkish_music');
                                } else if (row[0] === 'turkish_folk_music') {
                                    return this.$t('turkish_folk_music');
                                } else if (row[0] === 'popular_music_singing') {
                                    return this.$t('popular_music_singing');
                                } else if (row[0] === 'opera_and_choir_singing') {
                                    return this.$t('opera_and_choir_singing');
                                } else {
                                    return '';
                                }
                            },
                        },
                        {
                            label: '2.'+this.$t('program'),
                            field: this.getLocaleField('second_program_name'),
                            hidden: false
                        },
                        {
                            label: '2.'+this.$t('branch'),
                            field: 'second_program_detail',
                            hidden: false,
                            formatFn: (row) => {
                                return this.$t(row[0])
                            }
                        },
                        {
                            label: this.$t('academic_year'),
                            field: 'academic_year',
                            hidden: false,
                        },
                        {
                            label: this.$t('semester'),
                            field: this.getLocaleField('semester_name'),
                            hidden: false,
                        },
                        {
                            label: this.$t('application_group'),
                            field: 'application_group',
                            hidden: false,
                        },
                        {
                            label: this.$t('status'),
                            field: 'status',
                            hidden: false,
                            formatFn: (row) => {
                                let res = row
                                let clss = 'badge-warning'
                                if(row == 'waiting_program'){
                                    res = this.$t('waiting_program')
                                } else if(row == 'waiting'){
                                    res = this.$t('waiting')
                                }
                                return '<span class="badge '+clss+'">'+res+'</span>'
                            }
                        },
                        {
                            label: this.$t('result').toUpper(),
                            field: 'result',
                            hidden: false,
                            formatFn: (row) => {
                                let res = row
                                let clss = 'badge-warning'
                                if(row == 'waiting'){
                                    res = this.$t('waiting')
                                }
                                return '<span class="badge '+clss+'">'+res+'</span>'
                            }
                        }
                    ],
                    rows: [],
                    total: 0,
                    filterStatus: true,
                    showTable: false,
                    queryParams: {
                        filter: {},
                        sort: 'id',
                        page: 1,
                        limit: 20
                    }
                },
                branchs: null,
                updateData: {},
                updateTitle: null,
                updateMode: false,
                goTabIndex: 0,
                actions: [],

                statusOptions: [
                    {
                        value: 'waiting_program',
                        text: this.$t('waiting_program')
                    },
                    {
                        value: 'waiting',
                        text: this.$t('waiting')
                    },
                    {
                        value: 'approved',
                        text: this.$t('status_approved')
                    },
                    {
                        value: 'declined',
                        text: this.$t('status_declined')
                    }
                ],

                haveMessageOptions: [
                    {
                        value: 1,
                        text: this.$t('there_is')
                    },
                    {
                        value: '0',
                        text: this.$t('absent')
                    }
                ],

                bulkMsgForm: {},
                importModalTitle: '',
                importModalMode: null,
                importFile: null,
                groupOptions: [
                    {
                        value: 1,
                        text: 1
                    },
                    {
                        value: 2,
                        text: 2
                    }
                ]
            }
        },
        created() {
            this.filterSet();
            this.branchs = Branchs()
            this.actions = [
                {
                    text: this.$t('exam_info_download'),
                    permission: 'conservatoryapplication_examinformationexcelexport',
                    callback: () => {
                        this.examInformationExcelExport()
                    }
                },
                {
                    text: this.$t('exam_info_upload'),
                    permission: 'conservatoryapplication_examinformationexcelimport',
                    callback: () => {
                        this.$bvModal.show('importFormModal');
                        this.importModalTitle = this.$t('exam_info_upload')
                        this.importModalMode = 'exam_info_upload'
                        this.importFile = null
                    }
                },
                {
                    text: this.$t('exam_result_download'),
                    permission: 'conservatoryapplication_examresultexcelexport',
                    callback: () => {
                        this.examResultExcelExport()
                    }
                },
                {
                    text: this.$t('exam_result_upload'),
                    permission: 'conservatoryapplication_examresultexcelimport',
                    callback: () => {
                        this.$bvModal.show('importFormModal')
                        this.importModalTitle = this.$t('exam_result_upload')
                        this.importModalMode = 'exam_result_upload'
                        this.importFile = null
                    }
                },
                {
                    text: this.$t('exam_result_calc'),
                    permission: 'conservatoryapplication_calculateexampoints',
                    callback: () => {
                        this.calculateExamPoints()
                    }
                },
                {
                    text: this.$t('applicant_placement'),
                    permission: 'conservatoryapplication_placestudents',
                    callback: () => {
                        this.applicantPlacement()
                    }
                }
            ]
        },

        watch: {
            'datatable.queryParams.filter.program_code'(val){
                if (val){
                    this.branchs = Branchs(val)
                }
            },
        },

        methods: {
            formClear(){
              this.formProcess=null
            },
            filterSet() {
                this.datatable.queryParams.filter = {
                    national_id: null,
                }
            },
            filterClear() {
                this.filterSet()
                this.getRows();
            },
            filter() {
                this.datatable.queryParams.page = 1;
                this.getRows();
            },
            onPageChange(params) {
                this.datatable.queryParams.page = params.currentPage;
                this.getRows();
            },
            onPerPageChange(params) {
                this.datatable.queryParams.limit = params.currentPerPage;
                this.datatable.queryParams.page = 1;
                this.getRows();
            },
            changeColumn(key) {
                this.datatable.columns[key].hidden = this.datatable.columns[key].hidden == true ? false : true;
            },
            onSortChange(params) {
                const sortType = params[0].type == 'desc' ? '-' : '';
                this.datatable.queryParams.sort = sortType + params[0].field
                this.getRows();
            },

            getRows() {
                this.datatable.showTable = true;
                this.datatable.isLoading = true;
                if(this.datatable.queryParams.filter.national_id){
                    let nationalIds = this.datatable.queryParams.filter.national_id
                    if(typeof this.datatable.queryParams.filter.national_id == 'object'){
                        this.datatable.queryParams.filter.national_id = nationalIds.toString().split(`,`)
                    } else {
                        this.datatable.queryParams.filter.national_id = nationalIds.split(`\n`)
                    }
                }
                const config = {
                    params: {
                        ...this.datatable.queryParams
                    },
                    paramsSerializer: (params) => qs.stringify(params, {encode: false})
                };

                return ConservatoryService.getAll(config).then(response => {
                    this.datatable.rows = response.data.data
                    this.datatable.total = response.data.pagination.total
                }).catch(e => {
                    this.showErrors(e)
                }).finally(() => {
                    this.datatable.isLoading = false;
                });
            },

            openUpdateModal(data, updateMode, goTab){
                this.updateMode = updateMode
                this.formProcess='updateModal'
                this.updateTitle = data.name+' '+data.surname
                this.updateData = data
                this.goTabIndex = goTab
                this.$refs.updateModal.$refs.commonModal.show()
            },

            afterUpdate(){
                this.$refs.updateModal.$refs.commonModal.hide()
                this.getRows()
            },

            afterUpdateMsg(){
                this.getRows()
            },

            bulkMessage(){
                this.$refs.bulkMessageModal.$refs.commonModal.show()
            },

            async bulkMessageSend(){
                const isValid = await this.$refs.bulkMessageFormValidate.validate();
                if (isValid) {
                    let formData = {
                        filter: this.datatable.queryParams.filter,
                        ...this.bulkMsgForm
                    }
                    ConservatoryService.bulkMessage(formData).then(response => {
                        this.$toast.success(this.$t('api.'+response.data.message))
                        this.$refs.bulkMessageModal.$refs.commonModal.hide()
                        this.bulkMsgForm = {}
                    }).catch(e => {
                        this.showErrors(e)
                    })
                }
            },

            examInformationExcelExport(){
                ConservatoryService.examInformationExcelExport().then(response => {
                    this._downloadFile(response,this.$t('exam_info_download')+'.xlsx')
                }).catch(e => {
                    this.showErrors(e, null)
                })
            },

            async uploadFile(){
                const isValid = await this.$refs.importFormValidate.validate();
                if (isValid) {
                    if(this.importModalMode == 'exam_info_upload'){
                        let formData = new FormData()
                        formData.append('file', this.importFile);
                        ConservatoryService.importExamInformationExcelImport(formData).then(response => {
                            this.$toast.success(this.$t('proccess_success'))
                            this.$bvModal.hide('importFormModal')
                            this.importModalMode = null
                        }).catch(e => {
                            this.showErrors(e, this.$refs.importFormValidate)
                        })
                    } else if(this.importModalMode == 'exam_result_upload'){
                        let formData = new FormData()
                        formData.append('file', this.importFile);
                        ConservatoryService.importExamResultExcelImport(formData).then(response => {
                            this.$toast.success(this.$t('proccess_success'))
                            this.$bvModal.hide('importFormModal')
                            this.importModalMode = null
                        }).catch(e => {
                            this.showErrors(e, this.$refs.importFormValidate)
                        })
                    }
                }
            },

            examResultExcelExport(){
                ConservatoryService.examResultExcelExport().then(response => {
                    this._downloadFile(response,this.$t('exam_result_download')+'.xlsx')
                }).catch(e => {
                    this.showErrors(e, null)
                })
            },

            calculateExamPoints(){
                ConservatoryService.calculateExamPoints().then(response => {
                    this.$toast.success(this.$t('proccess_success'))
                }).catch(e => {
                    this.showErrors(e, null)
                })
            },

            excelExport(){
                if(this.datatable.queryParams.filter.national_id){
                    let nationalIds = this.datatable.queryParams.filter.national_id
                    if(typeof this.datatable.queryParams.filter.national_id == 'object'){
                        this.datatable.queryParams.filter.national_id = nationalIds.toString().split(`,`)
                    } else {
                        this.datatable.queryParams.filter.national_id = nationalIds.split(`\n`)
                    }
                }

                const config = {
                    params: {
                        ...this.datatable.queryParams
                    },
                    paramsSerializer: (params) => qs.stringify(params, {encode: false})
                }

                ConservatoryService.applicationExcelExport(config).then(response => {
                    this._downloadFile(response, this.$t('results')+'.xlsx')
                }).catch(e => {
                    this.showErrors(e, null)
                })
            },

            deleteApplication(data){
                this.$swal.fire({
                        text: this.$t('are_you_sure_to_delete'),
                        showCancelButton: true,
                        confirmButtonText: this.$t('yes'),
                        cancelButtonText: this.$t('no'),
                        icon: 'question'
                    }).then((result) => {
                        if (result.isConfirmed) {
                            ConservatoryService.deleteApplication(data.id).then(response => {
                                this.$toast.success(this.$t('api.'+response.data.message))
                                this.getRows()
                            }).catch(e => {
                                this.showErrors(e, null)
                            })
                        }
                    })
            },

            applicantPlacement(){
                this.$swal.fire({
                    text: this.$t('applicant_placement_info'),
                    showCancelButton: true,
                    confirmButtonText: this.$t('yes'),
                    cancelButtonText: this.$t('no'),
                    icon: 'question'
                }).then((result) => {
                    if (result.isConfirmed) {
                        ConservatoryService.applicantPlacement().then(response => {
                            this._downloadFile(response, this.$t('applicant_placement')+'.xlsx')
                            this.$toast.success(this.$t('proccess_success'))
                        }).catch(e => {
                            this.showErrors(e, null)
                        })
                    }
                })
            }

        }
    }
</script>

